import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';

// Extract translation keys
const EMAIL_VALIDATION_MESSAGES = {
  spaces: extractTranslation('validation.email.error.spaces'),
  atSymbol: extractTranslation('validation.email.error.at_symbol'),
  dot: extractTranslation('validation.email.error.dot'),
};

export class EmailValidators {
  public static emailFormatValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;

      if (!email) {
        return null; // Let required validator handle empty values
      }

      // Check for spaces
      if (email.includes(' ')) {
        return { invalidFormat: EMAIL_VALIDATION_MESSAGES.spaces };
      }

      // Check for exactly one @
      const atSymbols = email.split('@').length - 1;
      if (atSymbols !== 1) {
        return { invalidFormat: EMAIL_VALIDATION_MESSAGES.atSymbol };
      }

      // Check for at least one dot
      if (!email.includes('.')) {
        return { invalidFormat: EMAIL_VALIDATION_MESSAGES.dot };
      }

      return null;
    };
  };
}
